module.exports = __webpack_public_path__ + "030481f79417d864275e961b8c361517.png";